module.exports = __webpack_public_path__ + "static/img/pixfour.057a8e52.png";